// removed by extract-text-webpack-plugin
module.exports = {"navItem":"src-components----NavItem-module---navItem---20vMo","active":"src-components----NavItem-module---active---2DyOJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NavItem.module.styl
// module id = ./src/components/NavItem.module.styl
// module chunks = 35783957827783